export const environment = {
  production: false,
  ws: `wss://dev-rs2.reforce.group/connection/websocket`,
};

export const version = '1.7.3';
export const dsnSentry = 'https://a6c575015d557a24914a24edbe181ae5@sentry.reforce.group/13';
